// import React from "react";
// import {
//   Facebook,
//   Twitter,
//   Youtube,
//   Instagram,
//   Mail,
//   Phone,
//   MapPin,
//   Clock,
//   ChevronRight,
// } from "lucide-react";
// import logo from "../assets/images/logo/Header-logo.png";

// // COLORS declared at the top as requested
// const COLORS = {
//   bgPrimary: "#0B1C2D",   // Deep Navy
//   bgSecondary: "#13293D", // Slightly Lighter Navy
//   gold: "#C6A75E",        // Premium Gold
//   textLight: "#EAEAEA",
// };

// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   return (
//     <footer
//       className="text-gray-200 pt-24 pb-12 px-6 md:px-12 relative border-t-2"
//       style={{ backgroundColor: COLORS.bgPrimary, borderColor: COLORS.gold }}
//     >
//       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16 mb-20">

//         {/* LOGO & MISSION - Bolder Typography */}
//         <div className="space-y-8">
//           <div className="flex flex-col">
//             <img
//               src={logo}
//               alt="Shailendra Kumar Singh Logo"
//               className="w-72 h-auto object-contain mb-6 filter brightness-110"
//             />
//             <div className="h-[2px] w-32" style={{ backgroundColor: COLORS.gold }}></div>
//           </div>
//           <p className="text-lg leading-relaxed italic opacity-90 font-medium border-l-4 pl-6" style={{ borderColor: COLORS.gold }}>
//             "Justice is the constant and perpetual will to allot to every man
//             his due."
//           </p>
//           <div className="flex space-x-5 pt-4">
//             <SocialIcon icon={<Facebook size={20} />} />
//             <SocialIcon icon={<Twitter size={20} />} />
//             <SocialIcon icon={<Youtube size={20} />} />
//             <SocialIcon icon={<Instagram size={20} />} />
//           </div>
//         </div>

//         {/* QUICK LINKS - Increased Font Size */}
//         <div>
//           <h3 className="text-white text-xl font-bold mb-10 uppercase tracking-widest flex items-center gap-3">
//             <div className="w-3 h-3 rotate-45" style={{ backgroundColor: COLORS.gold }}></div>
//             Quick Links
//           </h3>
//           <ul className="space-y-5 text-lg font-medium">
//             <FooterLink label="Home" href="/" />
//             <FooterLink label="About Us" href="/about-us" />
//             <FooterLink label="Practice Areas" href="/practice-areas" />
//             <FooterLink label="Latest Blogs" href="/blog" />
//             <FooterLink label="Contact Us" href="/contact-us" />
//           </ul>
//         </div>

//         {/* PRACTICE AREAS - Increased Font Size */}
//         <div>
//           <h3 className="text-white text-xl font-bold mb-10 uppercase tracking-widest flex items-center gap-3">
//             <div className="w-3 h-3 rotate-45" style={{ backgroundColor: COLORS.gold }}></div>
//             Expertise
//           </h3>
//           <ul className="space-y-5 text-lg font-medium">
//             <FooterLink label="Civil Litigation" href="/services/civil-cases" />
//             <FooterLink label="Criminal Defense" href="/services/criminal-cases" />
//             <FooterLink label="Matrimonial Matters" href="/services/matrimonial-Cases" />
//             <FooterLink label="Company Related Issue" href="/services/company-related-issue" />
//             <FooterLink label="Cyber Matters" href="/services/cyber-cases" />
//           </ul>
//         </div>

//         {/* CONTACT & CHAMBERS - Bold Icons and Large Text */}
//         <div className="space-y-10">
//           <h3 className="text-white text-xl font-bold mb-10 uppercase tracking-widest flex items-center gap-3">
//             <div className="w-3 h-3 rotate-45" style={{ backgroundColor: COLORS.gold }}></div>
//             Chambers
//           </h3>
//           <div className="space-y-8 text-lg">
//             <div className="flex items-start gap-5 group">
//               <MapPin size={26} className="shrink-0 transition-all group-hover:scale-110" style={{ color: COLORS.gold }} />
//               <span className="leading-snug font-medium text-gray-200">
//                 Chamber No. 652, 6th Floor, <br />
//                 Lawyers Block, Saket Court, <br />
//                 New Delhi – 110017
//               </span>
//             </div>
//             <div className="flex items-center gap-5 group">
//               <Phone size={24} className="transition-all group-hover:scale-110" style={{ color: COLORS.gold }} />
//               <span className="font-bold text-white text-xl">+91 96259 75135</span>
//             </div>
//             <div className="flex items-center gap-5 group">
//               <Mail size={24} className="transition-all group-hover:scale-110" style={{ color: COLORS.gold }} />
//               <span className="font-medium hover:text-white transition-colors break-all">arunchaudhri1258@gmail.com</span>
//             </div>
//             <div className="flex items-center gap-5 pt-6 border-t border-white/10">
//               <Clock size={24} style={{ color: COLORS.gold }} />
//               <span className="text-sm font-black uppercase tracking-widest opacity-60">
//                 Mon – Sat: 09:00 – 19:00
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* COPYRIGHT BAR - Clear & Visible */}
//       <div className="border-t border-white/10 pt-12 text-center">
//         <p className="text-sm font-bold tracking-[0.5em] text-white uppercase mb-6 opacity-60">
//           © {currentYear} Shailendra Kumar Singh Law Firm | All Rights Reserved
//         </p>
//         <p className="text-xs text-gray-400 tracking-widest uppercase">
//           Design and Developed by{" "}
//           <a
//             href="https://www.digimarqtechnology.com/"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="text-white font-bold hover:underline underline-offset-8 transition-all"
//             style={{ color: COLORS.gold }}
//           >
//             Digimarq Technology Pvt Ltd
//           </a>
//         </p>
//       </div>
//     </footer>
//   );
// };

// // Social Icon Sub-component
// const SocialIcon = ({ icon }) => (
//   <a
//     href="#"
//     className="w-12 h-12 rounded-full border-2 border-white/10 flex items-center justify-center text-white transition-all duration-500 hover:scale-110 shadow-lg"
//     style={{ borderColor: `${COLORS.gold}40` }}
//     onMouseEnter={(e) => {
//         e.currentTarget.style.backgroundColor = COLORS.gold;
//         e.currentTarget.style.color = COLORS.bgPrimary;
//     }}
//     onMouseLeave={(e) => {
//         e.currentTarget.style.backgroundColor = "transparent";
//         e.currentTarget.style.color = "white";
//     }}
//   >
//     {icon}
//   </a>
// );

// // Link Sub-component
// const FooterLink = ({ label, href }) => (
//   <li className="flex items-center group cursor-pointer overflow-hidden">
//     <ChevronRight
//       size={18}
//       className="text-[#C6A75E] mr-3 -translate-x-6 opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-300"
//     />
//     <a
//       href={href}
//       className="text-gray-300 group-hover:text-white group-hover:translate-x-2 transition-all duration-300"
//     >
//       {label}
//     </a>
//   </li>
// );

// export default Footer;

import React from "react";
import { Link } from "react-router-dom";
import {
  Mail,
  Phone,
  MapPin,
  Scale,
  Info,
  Briefcase,
  BookOpen,
  MessageSquare,
  Gavel,
  ShieldAlert,
  Users,
  Building2,
  Globe,
  BookImage,
} from "lucide-react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import logo from "../assets/images/logo/logo1.png";

const COLORS = {
  gold: "#D4AF37",
  black: "#0A0A0A",
  border: "rgba(255,255,255,0.08)",
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ background: COLORS.black }} className="text-white">

      {/* CTA */}
      <div className="text-center py-12 px-6 border-b" style={{ borderColor: COLORS.border }}>
        <h3 className="text-2xl font-bold mb-3">Need Legal Help?</h3>
        <p className="text-gray-400 mb-6">
          Get professional legal consultation from experienced advocates.
        </p>
       <Link
  to="/contact-us"
  className="px-8 py-3 rounded-full font-bold bg-[#D4AF37] text-black hover:bg-white transition"
>
  Book Consultation
</Link>
      </div>

      {/* MAIN */}
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-4 gap-12 py-20 px-6">

        {/* ABOUT */}
        <div>
       
          <div className="flex justify-center pb-6">
        <img src={logo} alt="logo" className="h-[70px] opacity-90" />
      </div>

          <p className="text-sm text-gray-400 leading-relaxed">
            SKS Law Groups & Associates delivering trusted legal solutions with
            integrity and excellence.
          </p>

          <div className="flex gap-3 mt-6">
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <SocialIcon><FaFacebookF /></SocialIcon>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer">
              <SocialIcon><FaInstagram /></SocialIcon>
            </a>
          </div>
        </div>

        {/* LINKS */}
        <div>
          <h4 className="mb-4 font-bold">Quick Links</h4>
          <ul className="space-y-3">
            <FooterLink label="Home" href="/" icon={<Scale size={16} />} />
            <FooterLink label="About" href="/about-us" icon={<Info size={16} />} />
            <FooterLink label="Services" href="/services" icon={<Briefcase size={16} />} />
            <FooterLink label="Blog" href="/blogs" icon={<BookOpen size={16} />} />
            <FooterLink label="Gallery" href="/gallery" icon={<BookImage size={16} />} />
            <FooterLink label="Contact" href="/contact-us" icon={<MessageSquare size={16} />} />
          </ul>
        </div>

        {/* SERVICES */}
        <div>
          <h4 className="mb-4 font-bold">Practice Areas</h4>
          <ul className="space-y-3">
            <FooterLink label="Civil" href="/services/civil-lawyer" icon={<Gavel size={16} />} />
            <FooterLink label="Criminal" href="/services/criminal-lawyer" icon={<ShieldAlert size={16} />} />
            <FooterLink label="Matrimonial" href="/services/matrimonial-lawyer" icon={<Users size={16} />} />
            <FooterLink label="Corporate" href="/services/company-dispute-lawyer" icon={<Building2 size={16} />} />
            <FooterLink label="Cyber" href="/services/cyber-crime-lawyer" icon={<Globe size={16} />} />
          </ul>
        </div>

        {/* CONTACT */}
        <div>
          <h4 className="mb-4 font-bold">Contact</h4>

          <div className="flex gap-3 mb-3">
            <MapPin size={18} />
            <span className="text-sm text-gray-400">
              Saket Court, New Delhi
            </span>
          </div>

          <div className="flex gap-3 mb-3">
            <Phone size={18} />
            <span className="text-sm">+91 9818104905</span>
          </div>

          <div className="flex gap-3">
            <Mail size={18} />
            <span className="text-sm">skslawgroups@gmail.com</span>
          </div>
        </div>
      </div>



      {/* BOTTOM */}
      <div className="text-center text-xs py-6 border-t" style={{ borderColor: COLORS.border }}>
        © {currentYear} SKS Law Groups & Associates | Designed & Developed by 
        <a href="https://www.digimarqtechnology.com/" target="_blank" rel="noreferrer" className="ml-1 text-[#D4AF37]">
          Digimarq Technology
        </a>
      </div>
    </footer>
  );
};

/* COMPONENTS */

const SocialIcon = ({ children }) => (
  <div className="w-10 h-10 flex items-center justify-center rounded-full border border-white/10 hover:bg-[#D4AF37] hover:text-black transition">
    {children}
  </div>
);

const FooterLink = ({ label, href, icon }) => (
  <li>
    <Link to={href} className="flex items-center gap-2 text-sm text-gray-400 hover:text-white">
      {icon}
      {label}
    </Link>
  </li>
);

export default Footer;